
import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { MAudio } from "@/utils/audio";
import PlayLottie from '@/views/searchSpeaker/components/playLottie/playLottie.vue';
@Component({
  components: {
    PlayLottie
  },
})
export default class StylePopup extends Vue {
  @Prop({default: false}) visible: boolean
  @Prop({ default: () => [] })
  speakerEmotionCacheVOList: Array<any>;
  @Prop({ default: '' })
  speakerId: string;
  @Prop({ default: '' })
  currStyle: string;
  @Prop() theme: string

  show = false
  selectedValue = null
  playState = "initial"
  speakerAudio = null;
  currentMoodSpeaker = null;

  @Watch('speakerEmotionCacheVOList', {deep: true})
  listenCurrStyle(val) {
    console.log("listenCurrStyle", this.currStyle)
    const info = this.speakerEmotionCacheVOList && this.speakerEmotionCacheVOList.find(item => item.moodName === this.currStyle)
    const defaultInfo = this.speakerEmotionCacheVOList.find(item => item.moodName === '默认')
    if (info) {
      this.selectedValue = info.speakerId
    } else {
      this.selectedValue = defaultInfo.speakerId
    }
  }
  @Watch('speakerId', {})
  listenSpeakerId(val) {
    this.selectedValue = val;
    console.log("selectedValue", val)
  }

  @Watch('visible')
  listenVisible(val) {
    this.show = val
    if (val) {
      if (this.speakerAudio) return
      this.speakerAudio = MAudio.listen({//试听发音人声音
        playing: () => {
          this.playState = "playing";
        },
        pause: () => {
          this.playState = "paused";
          console.log('---当前播放状态',this.playState)
        },
        ended: () => {
          this.playState = "initial";
        }
      });
    } else {
      this.stopPlay()
    }
    console.log("listenVisible", this.speakerEmotionCacheVOList)
  }
  onPick(moodSpeaker,idx) {
    if (this.selectedValue === moodSpeaker.speakerId) {
      if (this.playState === 'initial') {
        // 重新开始播放
        this.playAudio(this.selectedValue,idx);
        
      } else if (this.playState === 'paused') {
        // 继续播放
        this.speakerAudio.play();
        this.playState = 'playing'
      } else if (this.playState === 'playing') {
        console.log('---暂停播放')
        // 暂停播放
        this.speakerAudio.pause();
        this.playState = 'paused';
      }
      return;
    }

    this.selectedValue = moodSpeaker.speakerId;

    // 重置播放器状态
    // this.resetAudio();//todo

    // 试听
    this.playAudio(this.selectedValue,idx);
    console.log('---this.selectedValue',this.selectedValue)
    this.currentMoodSpeaker = moodSpeaker
  }
  playAudio(speakerId,idx) {
    let demoUrl = this.speakerEmotionCacheVOList[idx].demoUrl;
    if(demoUrl){
      this.speakerAudio.setSrc(demoUrl);
      this.speakerAudio.play();
      this.playState ='playing';
    }
  }
  stopPlay(){
    this.speakerAudio.setSrc('');
    this.playState ='initial';
  }
  confirmStyle() {
    this.$emit('confirmStyle', this.currentMoodSpeaker.moodName)
  }
  closePopup() {
    this.show = false
    this.$emit('close')
  }
}